import { serviceCardLogic } from './versions/serviceCard';
import { packageContainerLogic, comparePackageLogic } from './versions/packageContainer';
import { sectionNumbersLogic } from './versions/sectionNumbers';

export function initContactUsRadioToggle(container: Element): void {
  if (container.getAttribute('data-contactus-radio-initialized') === 'true') return;
  container.setAttribute('data-contactus-radio-initialized', 'true');

  container.querySelectorAll('.cmp-form-options--radio').forEach((group) => {
    const radioButtons: NodeListOf<HTMLInputElement> =
      group.querySelectorAll('input[type="radio"]');
    const selectedRadio = Array.from(radioButtons).find((radio) => radio.checked);

    const toggleElements = (selector: string, className: string, add: boolean) => {
      container.querySelectorAll(selector).forEach((element) => {
        element.classList.toggle(className, add);
      });
    };

    const clearDisabledFieldErrors = () => {
      container.querySelectorAll('.cmp-disable-from-radio-button').forEach((element) => {
        element.classList.remove('error-input', 'flatepickr-error-input', 'error-select');
        element
          .querySelectorAll('.error-list-validation div, .error-list div')
          .forEach((msg) => msg.classList.add('input-hidden-error-messagge-vr'));
        element.querySelector('.flatpickr-error')?.classList.add('hidden');
      });
    };

    if (selectedRadio?.name === 'callback.asSoonAsPossible:boolean') {
      if (selectedRadio?.value === 'true') {
        toggleElements('.cmp-hide-from-radio-button', 'input-hidden-from-radio-button', true);
        toggleElements('.cmp-disable-from-radio-button', 'disabled-element-input-select', true);
      }
    }

    radioButtons.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        const selectedItem = event.target as HTMLInputElement;
        if (selectedItem.name === 'callback.asSoonAsPossible:boolean') {
          const selectedValue = (event.target as HTMLInputElement).value;
          const add = selectedValue === 'true';
          toggleElements('.cmp-hide-from-radio-button', 'input-hidden-from-radio-button', add);
          toggleElements('.cmp-disable-from-radio-button', 'disabled-element-input-select', add);
          if (add) {
            clearDisabledFieldErrors();
          }
        }
      });
    });
  });
}

export function containerLogic(): void {
  const editorialTextReadMore = (container: Element) => {
    const readMoreBtn = container.querySelector('.cmp-button__link') as HTMLElement;
    if (!readMoreBtn) return;
    const buttonCmp = readMoreBtn.querySelector('.cmp-button') as HTMLElement;
    const readMoreTextCmp = buttonCmp.querySelector('.cmp-button__text') as HTMLElement;
    const originalText = readMoreTextCmp.textContent ?? '';
    const altText = buttonCmp.dataset['altText'] ?? '';
    readMoreBtn.addEventListener('click', () => {
      container.classList.toggle('extended');
      readMoreTextCmp.textContent = container.classList.contains('extended')
        ? altText
        : originalText;
    });
  };

  document
    .querySelector('.accessibilityformcontainer .cmp-form__buttons-container')
    ?.classList.add('cmp-sumbit-btn-skeleton');

  const editorialInteractiveVisualList2ReadMore = (container: Element) => {
    const expandableSections = container.querySelectorAll('.cmp-visual-list-card');
    expandableSections.forEach((section) => {
      const expansionButtons = section.querySelectorAll('.button.cmp-button__link');
      expansionButtons.forEach((button: any) => {
        const btnCmp = button.querySelector('.cmp-button') as HTMLElement;
        const textCmp = button.querySelector('.cmp-button .cmp-button__text') as HTMLElement;
        const originalText = textCmp?.textContent ?? '';
        const altText = btnCmp?.dataset['altText'] ?? '';
        button.addEventListener('click', () => {
          if (section.classList.contains('cmp-visual-list-card-extended')) {
            section.classList.remove('cmp-visual-list-card-extended');
            textCmp.textContent = originalText;
          } else {
            section.classList.add('cmp-visual-list-card-extended');
            textCmp.textContent = altText;
          }
        });
      });
    });
  };

  const showMoreShowLessFunctionality = (container: Element) => {
    const contentExpandableButtonMore = container.querySelector(
      '.content-expandable-button--more'
    ) as HTMLElement;
    const contentExpandableButtonLess = container.querySelector(
      '.content-expandable-button--less'
    ) as HTMLElement;
    const expandableElements: HTMLElement[] = Array.from(container.querySelectorAll('.expandable'));

    let visibleCount = 1; // Show at least one by default

    const updateVisibility = () => {
      if (contentExpandableButtonMore) contentExpandableButtonMore.style.display = 'block';

      expandableElements?.forEach((el, index) => {
        el.style.display = index < visibleCount ? 'block' : 'none';
      });

      // Toggle buttons
      if (contentExpandableButtonMore)
        contentExpandableButtonMore.style.display =
          visibleCount < expandableElements.length ? 'block' : 'none';
      if (contentExpandableButtonLess)
        contentExpandableButtonLess.style.display = visibleCount > 1 ? 'block' : 'none';
    };

    contentExpandableButtonMore?.addEventListener('click', () => {
      if (visibleCount < expandableElements.length) {
        visibleCount += 1;
        updateVisibility();
      }
    });

    contentExpandableButtonLess?.addEventListener('click', () => {
      if (visibleCount > 1) {
        visibleCount -= 1;
        updateVisibility();
      }
    });

    updateVisibility(); // Initialize view
  };

  const onDocumentReady = (): void => {
    document.querySelectorAll('.container').forEach((container) => {
      if (container.classList.contains('service-card')) {
        serviceCardLogic(container as HTMLElement);
      } else if (container.classList.contains('package-container')) {
        packageContainerLogic(container as HTMLElement);
      } else if (container.classList.contains('compare-package-container')) {
        comparePackageLogic(container as HTMLElement);
      } else if (container.classList.contains('section-numbers__item')) {
        sectionNumbersLogic(container as HTMLElement);
      } else if (container.classList.contains('js-automatic-background')) {
        if (container.querySelectorAll('.cmp-accordion__item').length > 0) {
          //What we need
          const firstActiveImg = container
            .querySelector(
              '.cmp-accordion__item.cmp-accordion__item--expanded .cmp-accordion__panel.cmp-accordion__panel--expanded .imagevideo .cmp-media__image'
            )
            ?.getAttribute('src');

          const switchTabs = container.querySelectorAll('.cmp-accordion__item');

          //Methods
          const switchAccBackImage = (imgToAdd: string, target: Element) => {
            if (imgToAdd) {
              (target as HTMLElement).style.backgroundImage = `url(${imgToAdd})`;
            }
          };

          const onClassChange = (node: Element, callback: any) => {
            let lastClassString = node.classList.toString();

            const mutationObserver = new MutationObserver((mutationList) => {
              for (const item of mutationList) {
                if (item.attributeName === 'class') {
                  const classString = node.classList.toString();
                  if (classString !== lastClassString) {
                    callback(item.target);
                    lastClassString = classString;
                    break;
                  }
                }
              }
            });

            mutationObserver.observe(node, { attributes: true });

            return mutationObserver;
          };

          //Initial check
          editorialInteractiveVisualList2ReadMore(container);
          if (firstActiveImg != null) {
            switchAccBackImage(firstActiveImg, container);
            container.classList.add('backgroundImageContainerInteractiveVisualList2');
          }
          //Eventlistener
          switchTabs.forEach((tab) => {
            onClassChange(tab, (me: any) => {
              if (me.classList.contains('cmp-accordion__item--expanded')) {
                switchAccBackImage(
                  me
                    .querySelector(
                      '.cmp-accordion__panel.cmp-accordion__panel--expanded .imagevideo .cmp-media__image'
                    )
                    ?.getAttribute('src'),
                  container
                );
              }
            });
          });
        } else {
          const img = container
            .querySelector('.cmp-carousel__item--active .cmp-teaser__image img')
            ?.getAttribute('src');
          container.classList.add('backgroundImageContainerCarousel');
          if (img) {
            (container as HTMLElement).style.backgroundImage = `url(${img})`;
          }
        }
      } else if (container.classList.contains('contactus-container')) {
        initContactUsRadioToggle(container);
      } else if (container.classList.contains('cmp-container__sticky-button-container')) {
        const stickyButtons: NodeListOf<Element> = container.querySelectorAll('.button');

        //Direction of sticky button elements based on position of container
        stickyButtons.forEach((button) => {
          button.classList.add('cmp-button__sticky-button');
          if (container.classList.contains('left')) {
            if (button.classList.contains('-position-right')) {
              button.classList.remove('-position-right');
            }
          } else if (!container.classList.contains('left')) {
            if (!button.classList.contains('-position-right')) {
              button.classList.add('-position-right');
            }
          }
        });

        const backToTopButton: HTMLElement | null = container.querySelector('.backToTopButton');

        if (backToTopButton) {
          backToTopButton.classList.add('hide');

          const scrollThreshold = 600;
          //Event listener to show back to top sticky button after scrolling
          document.body.addEventListener('scroll', () => {
            const scrollPosition: number =
              document.documentElement.scrollTop || document.body.scrollTop;

            if (scrollPosition > scrollThreshold) {
              backToTopButton.classList.remove('hide');
            } else {
              backToTopButton.classList.add('hide');
            }
          });

          //Event listener for back to top sticky button
          backToTopButton.addEventListener('click', () => {
            document.body.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
              document.body.scrollTo({ top: 0, behavior: 'instant' });
            }, 500);
          });
        }
      } else if (container.classList.contains('editorial-text')) {
        editorialTextReadMore(container);
      } else if (container.classList.contains('js-all-equal-height-sons')) {
        const sons = container.querySelectorAll(':scope > div.cmp-container div.container');
        let maxHeight = 0;
        sons?.forEach((son) => {
          if ((son as HTMLElement).offsetHeight > maxHeight) {
            maxHeight = (son as HTMLElement).offsetHeight;
          }
        });
        sons?.forEach((son) => {
          (son as HTMLElement).style.height = maxHeight + 'px';
        });
      }
      if (container.classList.contains('expandable-content--desktop')) {
        showMoreShowLessFunctionality(container);
      }
      if (container.classList.contains('expandable-content--mobile')) {
        if (window.innerWidth <= 768) {
          showMoreShowLessFunctionality(container);
        }
      }
      if (container.querySelector('.itinerarycruisecard')) {
        const updateCtaPosition = () => {
          const navigators = container.querySelector('.navigators');
          const ctaText = container.querySelector('.cmp-button__text');
          const ctaDiv = container.querySelector('.button.cmp-button__link') as HTMLElement | null;

          if (!ctaDiv || !navigators || !ctaText) return;

          const navigatorsRect = navigators.getBoundingClientRect();
          if (navigatorsRect.height === 0) return;

          const originTop = (ctaDiv.offsetParent ?? container).getBoundingClientRect().top;
          const navigatorsCenterOfMass_top =
            navigatorsRect.top - originTop + navigatorsRect.height / 2;

          ctaDiv.style.top = `${
            navigatorsCenterOfMass_top - ctaText.getBoundingClientRect().height / 2
          }px`;
        };

        const observer = new MutationObserver(updateCtaPosition);
        observer.observe(container, {
          childList: true,
          subtree: true,
        });

        const tabPanel = container.closest('.cmp-tabs__tabpanel');
        if (tabPanel) {
          const visibilityObserver = new MutationObserver(updateCtaPosition);
          visibilityObserver.observe(tabPanel, {
            attributes: true,
            attributeFilter: ['class', 'hidden', 'inert', 'aria-hidden'],
          });
        }

        if (typeof ResizeObserver !== 'undefined') {
          const resizeObserver = new ResizeObserver(updateCtaPosition);
          resizeObserver.observe(container);
        }
      }
    });
  };

  if (document.readyState !== 'loading') {
    onDocumentReady();
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady);
  }
}

containerLogic();
